import { useState } from 'react';
import { Heading, InlineMessage } from '@invisionag/components';
import { useTranslation } from '@invisionag/next/i18n';
import { useRouter, useSearchParams } from 'next/navigation';
import { CenteredContainer } from '../../_components/centered-container';
import { VerificationForm } from '../../_components/setup-2fa/verification-form';
import { ConfirmationForm } from '../../_components/setup-2fa/confirmation-form';
import { SetView } from './page';
import { getRedirectUrl } from '@/lib/utils';

export interface Setup2FAOptions {
  provisioningUri: string;
  recoveryCodes: string[];
  secret: string;
}

export function Setup2FAForm({
  setView,
  provisioningUri,
  recoveryCodes,
  secret,
}: { setView: SetView } & Setup2FAOptions) {
  const { t } = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();
  const returnUrl = searchParams.get('return_url');
  const [verified, setVerified] = useState(false);

  return (
    <CenteredContainer preferredWidth="45rem" hideLogo>
      <Heading level={1} className="text-center">
        {t('login.setup-2fa-form.heading')}
      </Heading>
      <InlineMessage>
        {t('login.setup-2fa-form.enforcement.message')}
      </InlineMessage>
      <p>{t('login.setup-2fa-form.enforcement.hint')}</p>
      {verified ? (
        <ConfirmationForm
          recoveryCodes={recoveryCodes}
          onSuccess={() => router.replace(getRedirectUrl(returnUrl))}
          onCancel={() => setView('login')}
          onTimeout={(message) => setView('login', { message })}
        />
      ) : (
        <VerificationForm
          provisioningUri={provisioningUri}
          secret={secret}
          onSuccess={() => setVerified(true)}
          onCancel={() => setView('login')}
          onTimeout={(message) => setView('login', { message })}
        />
      )}
    </CenteredContainer>
  );
}
